// extracted by mini-css-extract-plugin
export default {"row":"styles_row__E0o3q","maintitle":"styles_maintitle__dXxcd","searchCol":"styles_searchCol__Fy4kN"};